import { i18nMark } from 'lingui-react';

const formattedMessages = {
  backToTopButton: i18nMark('Back to Top'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./components/AppBody/messages.js